<ng-container *ngIf="day">
    <span class="day__label" title="{{day | propercase}}">{{dayInfo[day].abbr}}</span>
    <div class="day__viz contains-multiple--{{shiftInfos.length}}" [ngClass]="{'contains-multiple':shiftInfos.length > 1}">
        <!--
            0000 0030 0100 0130 0200 0230 0300 0330 0400 0430
            0500 0530 0600 0730 0800 0830 0900 0930 1000 1030
            1100 1130 1200 1230 1300 1330 1400 1430 1500 1530
            1600 1630 1700 1730 1800 1830 1900 1930 2000 2030
            2100 2130 2200 2230 2300 2330 2400

            2400 == 100%
            0000 == 0%

            Sample shift 1200 - 2400
                        =1200
                         1200 / 2400
                         0.5 * 100 = 50
                         1200 / 2400 (start)
          -->
        <div class="day__current" *ngIf="isToday"
            title="{{timeWherePersonIs ? timeWherePersonIs : (now | date: 'h:mmaa')}}" [ngStyle]="currentTimeStyle"
            [matTooltipClass]="'day__current--tooltip'"
            matTooltip="Time where you are: {{now | date: 'h:mmaa'}}&#13; {{timeWherePersonIs ? 'Time where person is: ' + timeWherePersonIs : ''}}"
            matTooltipPosition="above"> </div>

        <ng-container *ngFor="let shiftInfo of shiftInfos; let i = index">
            <div *ngIf="shiftInfo" class="day__shift day__shift--{{i + 1}}" title="{{shiftTimeString(shiftInfo)}}"
                [ngStyle]="fillStyle(shiftInfo)" [ngClass]="
            {
                'day__shift--short': shiftIsShort(shiftInfo),
                'day__shift--early': shiftIsShort(shiftInfo) && shiftStartsEarly(shiftInfo),
                'day__shift--late': shiftIsShort(shiftInfo) && shiftEndsLate(shiftInfo)
            }
            ">
                <div class="day__times">
                    <div class="day__time day__time--start">{{parse24HourTime(shiftInfo.startTime)[0]}}
                        <span class="day__ampm">{{parse24HourTime(shiftInfo.startTime)[1]}} </span>
                    </div>
                    -
                    <div class="day__time day__time--end">{{parse24HourTime(shiftInfo.endTime)[0]}}
                        <span class="day__ampm">{{parse24HourTime(shiftInfo.endTime)[1]}}</span>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="day__segment day__segment--1"></div>
        <div class="day__segment day__segment--2"></div>
        <div class="day__segment day__segment--3"></div>
        <div class="day__segment day__segment--4"></div>
        <div class="day__segment day__segment--5"></div>
    </div>
</ng-container>